module.exports = __webpack_public_path__ + "static/media/Cobalion_gaussian2.0f52a331.png";